<template>
  <PortalLayout section="Reports">
    <div v-if="isPropertyLoading"><Loading /></div>
    <div class="pt-10" v-else>
      <div class="flex flex-col ml-2">
        <router-link class="w-64 mb-4" to="reports/trainingreport">
          <BaseButton class="w-full" :icon-only="false"> Training Report </BaseButton>
        </router-link>
        <router-link class="w-64 mb-4" to="reports/propertyrosterreport">
          <BaseButton class="w-full" :icon-only="false"> Property Roster </BaseButton>
        </router-link>
        <router-link class="w-64 mb-4" to="reports/mobilityreport">
          <BaseButton class="w-full" :icon-only="false"> Mobility Report </BaseButton>
        </router-link>
        <router-link class="w-64 mb-4" to="reports/vrreport">
          <BaseButton class="w-full" :icon-only="false"> VR Report </BaseButton>
        </router-link>
        <router-link class="w-64 mb-4" to="reports/vrfilterreport">
          <BaseButton class="w-full" :icon-only="false"> VR Filter Report </BaseButton>
        </router-link>
        <router-link class="w-64 mb-4" to="reports/tenantcontactreport">
          <BaseButton class="w-full" :icon-only="false">
            Tenant Contact Roster
          </BaseButton>
        </router-link>
        <router-link class="w-64 mb-4" to="reports/trainingexpirationreport">
          <BaseButton class="w-full" :icon-only="false">
            Training Expiration Report
          </BaseButton>
        </router-link>
      </div>
    </div>
  </PortalLayout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../../store/bldgStore";

const bldgStore = useBldgStore();
var isPropertyLoading = computed(() => bldgStore.isLoading);
</script>
